var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldAirpod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92 11.342c-.64 0-1.27-.26-1.72-.72-.14-.14-.26-.29-.36-.46-.18-.3-.5-.49-.85-.49H3.5c-.55 0-1 .45-1 1v6.83c0 2.49 2.01 4.5 4.5 4.5h10c2.49 0 4.5-2.01 4.5-4.5v-6.83c0-.55-.45-1-1-1H18c-.36 0-.68.2-.86.51a2.42 2.42 0 0 1-2.06 1.16H8.92zM7 2C4.51 2 2.5 4.01 2.5 6.5v.67c0 .55.45 1 1 1H6c.36 0 .68-.2.86-.51A2.42 2.42 0 0 1 8.92 6.5h5.99c.61 0 1.49.32 1.91.75.13.13.23.27.33.42.18.3.5.5.86.5h2.5c.55 0 1-.45 1-1V6.5A4.509 4.509 0 0 0 17 2H7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAirpod);
export default __webpack_public_path__ + "static/media/vuesax-bold-airpod.c5196e0b6f1245ef2b218862c0edcc2c.svg";
export { ForwardRef as ReactComponent };